import { defineComponent, ref, computed } from 'vue-demi';
import { openBlock, createElementBlock, normalizeClass, createElementVNode, renderSlot } from 'vue';

const Hint = [
// Layout
'layout-row !items-start justify-between',
// Spacing
'gap-sm',
// Typography
'typography-caption-regular',
// Theme
'theme-foreground-outline', 'dark:theme-foreground-outline-dark'];
const HintText = [
// Interactivity
'interactivity-default'];
const HintAddon = [
// Layout
'layout-inline-row empty:hidden',
// Typography
'whitespace-nowrap'];

var script = defineComponent({
  name: 'OrHint',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  expose: ['root'],
  setup() {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-hint-v3', ...Hint]);
    const textStyles = computed(() => [...HintText]);
    const addonStyles = computed(() => [...HintAddon]);
    return {
      root,
      rootStyles,
      textStyles,
      addonStyles
    };
  }
});

const _hoisted_1 = ["disabled"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    disabled: _ctx.disabled
  }, [createElementVNode("div", {
    class: normalizeClass(_ctx.textStyles)
  }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */), createElementVNode("div", {
    class: normalizeClass(_ctx.addonStyles)
  }, [renderSlot(_ctx.$slots, "addon")], 2 /* CLASS */)], 10 /* CLASS, PROPS */, _hoisted_1);
}

script.render = render;
script.__file = "src/components/or-hint-v3/OrHint.vue";

export { script as s };
